import { HttpRequest, HttpResponse } from '@angular/common/http';

export class DocumentRequestBatchMockService {
  /**
   * Mocks the document overview for a specific Document Request Batch.
   *
   * GET /document-request-batches/{batchId}/documents
   */
  public getDocumentOverview(_request: HttpRequest<any>, _batchId: string): HttpResponse<any> {
    return new HttpResponse({
      status: 200,
      body: {
        requested: [
          {
            id: 'doc-2',
            name: 'Tax Residency Certificate',
            description: 'Certificate confirming current tax residency',
            signature_requirements: 'None required',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: null,
          },
          {
            id: 'doc-3',
            name: 'Dividend Voucher 2023',
            description: 'Dividend voucher for FY2023',
            signature_requirements: 'None required',
            beneficial_owner: null,
            notes: 'Please include all dividend lines',
            rejection_reason: null,
          },
        ],
        review_required: [
          {
            id: 'doc-1',
            name: 'W-8BEN Form',
            description: 'Certificate of Foreign Status',
            signature_requirements: 'Wet ink signature required',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: 'Signature missing on page 2',
          },
        ],
        awaiting_approval: [],
        approved: [
          {
            id: 'doc-4',
            name: 'Proof of Identity',
            description: 'Government-issued photo ID',
            signature_requirements: 'None required',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: null,
          },
          {
            id: 'doc-5',
            name: 'Bank Statement',
            description: 'Most recent 3-month statement',
            signature_requirements: 'None required',
            beneficial_owner: null,
            notes: null,
            rejection_reason: null,
          },
        ],
      },
    });
  }

  /**
   * Mocks the download of generated files for a specific Document Request Batch.
   * According to the technical design, this endpoint should return a ZIP file URL.
   *
   * POST /document-request-batches/{batchId}/generated-files-archives
   */
  public getGeneratedFilesZip(request: HttpRequest<any>, batchId: string): HttpResponse<any> {
    // Technical Requirement: The frontend MUST issue the request with header Accept: application/zip
    const acceptHeader = request.headers.get('Accept');

    if (acceptHeader !== 'application/zip') {
      return new HttpResponse({
        status: 406,
        statusText: 'Not Acceptable',
        body: { error: 'Accept header must be application/zip' },
      });
    }

    // In a real scenario, this URL would be generated by the wtax-archive-service
    // and returned by Salesforce.
    const mockZipUrl = `https://mock-archive-service.wtax.co/v1/archives/batch-${batchId}-generated-docs.zip`;
    const mockFileName = `batch-${batchId}-docs.zip`;

    return new HttpResponse({
      status: 200,
      body: {
        archive_file_url: mockZipUrl,
        file_name: mockFileName,
      },
    });
  }
}
